import { createMuiTheme } from '@material-ui/core/styles';
import { darkTheme } from 'material-ui-apollo';
import theme from 'apollo-react-next/theme';

export const appTheme = createMuiTheme({
  palette: {
    primary: {
      main: '#297dfd',
    },
    grey: {
      400: '#d9d9d9',
      700: '#999999',
      800: '#666666',
    },
    background: {
      default: '#f6f6f6',
    },
    divider: '#e5efff',
    error: {
      main: '#dd2626',
    },
  },
  typography: {
    useNextVariants: true,
    fontFamily: 'Noto Sans, sans-serif',
  },
  overrides: {
    InfoLabel: {
      popper: {
        zIndex: 9999,
      },
    },
    MuiButton: {
      root: {
        textTransform: 'none',
      },
    },
    MuiTablePagination: {
      select: {
        paddingRight: '24px',
      },
      selectIcon: {
        top: 'calc(50% - 12px)',
      },
    },
  },
  menu: {
    active: {
      background: 'rgba(255, 255, 255, .27)',
    },
  },
  chart: {
    background: theme.palette.background.paper,
    line: {
      0: theme.palette.primary.main,
      1: '#F17800',
      2: '#7F3BA7',
      3: '#E2B627',
      4: '#43B649',
      5: '#DD4477',
      6: '#0099C6',
    },
    fill: {
      0: theme.palette.primary.main,
      1: theme.palette.primary.light,
    },
    bar: {
      0: theme.palette.primary.light,
      1: theme.palette.primary.dark,
    },
  },
  darkChart: {
    background: darkTheme.palette.background.paper,
    line: {
      0: theme.palette.grey[50],
      1: '#F17800',
      2: '#7F3BA7',
      3: '#E2B627',
      4: '#43B649',
      5: '#DD4477',
      6: '#0099C6',
    },
    fill: {
      0: theme.palette.secondary.dark,
      1: theme.palette.primary.light,
    },
    bar: {
      0: theme.palette.primary.light,
      1: theme.palette.secondary.dark,
    },
  },
});



// WEBPACK FOOTER //
// ./src/Shared/Themes/appTheme.js